import React, { useState, useEffect } from 'react';

import BookingWidget from './BookingWidget';

// Importe suas imagens aqui
import img1 from '../images/safira6.jpeg';
import img2 from '../images/cristal6.jpeg'; // Substitua pelo nome real do seu arquivo na pasta images
import img3 from '../images/cristal4.jpeg'; // Substitua pelo nome real do seu arquivo na pasta images

const heroImages = [
  img1,
  img2,
  img3
];

const Hero = () => {
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % heroImages.length);
    }, 7000); // Sincronizado com o CSS (7s) para mostrar a imagem toda

    return () => clearInterval(interval);
  }, []);

  return (
    // Adicionamos um className para poder estilizar no CSS
    <section className="hero-section" id="hero">
      <div className="hero-background-carousel">
        {heroImages.map((img, index) => (
          <div
            key={index}
            className={`hero-bg-image ${index === currentImage ? 'active' : ''}`}
            style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${img})` }}
          />
        ))}
      </div>
      <div className="hero-content">
        <div className="hero-text-container">
          <h1>Cabanas de Vidro: Elegância e Conforto aos Pés da Pedra do Baú</h1>
          <p>Imagine acordar a 1.500 metros de altitude, onde o conforto encontra a natureza bruta da Serra da Mantiqueira. Localizadas em São Bento do Sapucaí, as Cabanas de Vidro são mais que uma hospedagem: são um convite para se desconectar do mundo e se reconectar com quem você ama.</p>
        </div>
        <BookingWidget />
      </div>
    </section>
  );
};

export default Hero;
